import React from "react";
import {
  Pagination as BsPagination,
  PaginationItem as BsPaginationItem,
  PaginationLink as BsPaginationLink,
} from "reactstrap";

type Props = Readonly<{
  currentJobs: number;
  currentPage: number;
  nextPage: () => void;
  prevPage: () => void;
  totalJobs: number;
  totalPages: number;
}>;

export const Pagination = ({
  currentPage,
  currentJobs,
  nextPage,
  prevPage,
  totalJobs,
  totalPages,
}: Props) => {
  let contents = null;
  if (totalJobs < 1) {
    contents = <span className="text-muted">No jobs found.</span>;
  } else {
    contents = (
      <>
        Page <strong>#{currentPage}</strong> of <strong>{totalPages}</strong>{" "}
        <small>
          (showing <strong>{currentJobs}</strong> of <strong>{totalJobs}</strong> total jobs)
        </small>
      </>
    );
  }
  return (
    <BsPagination aria-label="Job list navigation">
      <BsPaginationItem disabled={currentPage === 1}>
        <BsPaginationLink
          href="#"
          onClick={e => {
            e.preventDefault();
            prevPage();
          }}
          previous
          title="Previous page"
        />
      </BsPaginationItem>
      <BsPaginationItem className="flex-fill text-center " disabled>
        <BsPaginationLink className="text-dark" href="#">
          {contents}
        </BsPaginationLink>
      </BsPaginationItem>
      <BsPaginationItem disabled={currentPage >= totalPages}>
        <BsPaginationLink
          href="#"
          next
          onClick={e => {
            e.preventDefault();
            nextPage();
          }}
          title="Next page"
        />
      </BsPaginationItem>
    </BsPagination>
  );
};
Pagination.displayName = "Pagination";
